export { BasicCatchInfoCards } from './BasicCatchInfoCards';
